module.exports = __webpack_public_path__ + "static/media/externalBarn_11.d3d7efbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_11.png
// module id = 1299
// module chunks = 3